  // Define columns
  export const group1 = [
    {
      "key": "WorkUser_TaSeiban",
      "name": "製番",
      "width": 75,
      "minWidth": 60,
      "group": "group1"
    },
    {
      "key": "Order_Code Work_OperationProcNo",
      "name": "製造オーダ<br>工順",
      "width": 75,
      "minWidth": 60,
      "group": "group1"
    },
    {
      "key": "Work_OrderItem",
      "name": "品番",
      "width": 75,
      "minWidth": 70,
      "group": "group1"
    },
    {
      "key": "Work_OrderItemName",
      "name": "品名",
      "width": 85,
      "minWidth": 85,
      "group": "group1"
    }
  ];
  export const group2 = [
    {
      "key": "Work_OperationProductionStartTime",
      "name": "製造<br>開始日時",
      "width": 85,
      "minWidth": 70,
      "group": "group2"
    },
    {
      "key": "Work_OperationProductionEndTime",
      "name": "製造<br>終了日時",
      "width": 85,
      "minWidth": 70,
      "group": "group2"
    },
    {
      "key": "Work_ResultStartTime",
      "name": "実績<br>開始日時",
      "width": 95,
      "minWidth": 70,
      "group": "group2"
    },
    {
      "key": "Work_ResultEndTime",
      "name": "実績<br>終了日時",
      "width": 95,
      "minWidth": 70,
      "group": "group2"
    },
    {
      "key": "completedReset",
      "name": "着完<br>削除",
      "width": 90,
      "minWidth": 70,
      "group": "group2"
    }
  ];
  export const group3 = [
    {
      "key": "Order_LET Order_Qty",
      "name": "納期<br>数量",
      "width": 70,
      "minWidth": 60,
      "group": "group3"
    },
    {
      "key": "Work_Lateness",
      "name": "遅れ<br>日数",
      "width": 70,
      "minWidth": 60,
      "group": "group3"
    },
    {
      "key": "Work_OperationMainRes",
      "name": "資源名",
      "width": 70,
      "minWidth": 60,
      "group": "group3"
    }
  ];
